import React, { Component } from "react"

class Recent extends Component {
  componentDidMount() {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://embed.radio.co/embed/s369d6f962/history.js?l=20";
    this.div.appendChild(script);
  }
  render() {
    return (
      <div className="Recent" ref={el => (this.div = el)}></div>
    );
  }
}

export default Recent;